import React from "react";

const ButtonLoader = ({width="22px", height="22px"}) => {
  return (
      <div className="spinner-border" style={{width,height}} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
  );
};

export default ButtonLoader;
